import { initAxiosRH, loadAbort } from "#api/axios.service"
const axios=initAxiosRH()
const SAVINGS_FUND="savings-fund"
const STATUS=`${SAVINGS_FUND}/status`
const EXCEL=`${SAVINGS_FUND}/excel`

export const savingsFundGet = (params) => {
    const controller= loadAbort()
    const call= axios.get(SAVINGS_FUND,{params,signal:controller.signal})
    return {call,controller}
}

export const savingsFundPost = (data) => {
    const controller= loadAbort()
    const call= axios.post(SAVINGS_FUND,data,{signal:controller.signal})
    return {call,controller}
}
export const savingsFundPut = (data) => {
    const controller= loadAbort()
    const call= axios.put(SAVINGS_FUND,data,{signal:controller.signal})
    return {call,controller}
}
export const savingFundPut = (id,data) => {
    const controller= loadAbort()
    const call= axios.put(`${SAVINGS_FUND}/${id}`,data,{signal:controller.signal})
    return {call,controller}
}
export const savingsFundStatusGet = (params) => {
    const controller= loadAbort()
    const call= axios.get(STATUS,{params,signal:controller.signal})
    return {call,controller}
}
export const savingsFundExcelGet = (params) => {
    const controller= loadAbort()
    const call= axios.get(EXCEL,{params,signal:controller.signal,responseType: "blob" })
    return {call,controller}
}
